import request from "@/api/request";

export function list() {
    return request({
        url: '/api/subscription/list',
        method: 'get',
    })
}

export function info(val) {
    return request({
        url: `/api/subscription/info/${val}`,
        method: 'get'
    })
}

